import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  postQueueConfigUserPreferenceForBusiness,
} from "apis";
import { getQueueConfigQueryKey } from "./get-queue-config";
import { useMyAccessProfileV2 } from "./get-my-access-profile";

const usePostQueueConfigUserPreference = () => {
  const queryClient = useQueryClient();
  const { data: myAccessProfile } = useMyAccessProfileV2();

  return useMutation(postQueueConfigUserPreferenceForBusiness, {
    onSuccess: () =>
      queryClient.invalidateQueries(
        getQueueConfigQueryKey({
          businessId: myAccessProfile?.business?.id || "",
        })
      ),
  });
};

export default usePostQueueConfigUserPreference;
